import { Celula } from '@/componentes/celula';
import { Carregando, Falha } from '@/componentes/estado-da-tela';
import { Valor } from '@/componentes/valor';
import { mensagemDoErro, useResumoAdmin } from '@/dados';

/* Os números do topo. Contagem pura: nada aqui é calculado pelo motor.
 *
 * A leitura que estes seis blocos entregam, em ordem: quanta gente chegou,
 * quanta virou conta, quanto trabalho foi feito e quanto disso é dos últimos
 * dias. É a pergunta "está crescendo ou parou". */

function Numero({ rotulo, valor, nota }: { rotulo: string; valor: number; nota?: string }) {
  return (
    <Celula respiro="justo" className="grid gap-1">
      <p className="rotulo">{rotulo}</p>
      <Valor valor={valor} formato="inteiro" tamanho="titulo" />
      {nota ? <p className="text-tinta-2 text-nota">{nota}</p> : null}
    </Celula>
  );
}

export function VisaoGeral() {
  const resumo = useResumoAdmin();

  if (resumo.isPending) return <Carregando linhas={2} rotulo="Carregando os números." />;
  if (resumo.isError) {
    return (
      <Falha
        oQue="o resumo"
        motivo={mensagemDoErro(resumo.error)}
        aoTentarDeNovo={() => void resumo.refetch()}
      />
    );
  }

  const r = resumo.data;
  const semConta = r.contas - r.contas_cadastradas;

  return (
    <div className="grid gap-3 @campos:grid-cols-2 @painel-largo:grid-cols-3">
      <Numero rotulo="Contas" valor={r.contas} nota={`${semConta} ainda sem cadastro`} />
      <Numero rotulo="Com e-mail e senha" valor={r.contas_cadastradas} />
      <Numero
        rotulo="Empresas"
        valor={r.empresas}
        nota={`${r.empresas_com_cnpj} com CNPJ informado`}
      />
      <Numero rotulo="Projetos" valor={r.projetos} nota={`${r.orcamentos} análises salvas`} />
      <Numero rotulo="Relatórios gerados" valor={r.diagnosticos} />
      <Numero
        rotulo="Visitas em 7 dias"
        valor={r.acessos_7d}
        nota={`${r.ativos_7d} pessoas diferentes, ${r.acessos_30d} visitas em 30 dias`}
      />
    </div>
  );
}
